import { Model } from 'survey-react-ui';

type CreateSurveyEventHandlersProps = {
  updateSurvey: (survey: Model, complete: boolean, forceUpload?: boolean) => Promise<void>;
};

const createSurveyEventHandlers = ({ updateSurvey }: CreateSurveyEventHandlersProps) => ({
  onPageChange: (survey: Model) => {
    updateSurvey(survey, false, true);
  },
  onComplete: (survey: Model) => {
    updateSurvey(survey, true, true);
  },
  onValueChange: (survey: Model) => {
    updateSurvey(survey, false);
  },
});

export { createSurveyEventHandlers };
